import { createSelector } from 'reselect'
import { find } from 'lodash-es'

import { intToBool } from '../../utils'

export default ({ getFeatureRoot }) => {
  const getPolls = (state) => getFeatureRoot(state).polls

  const getActivePoll = createSelector([getPolls], (polls) =>
    find(
      polls,
      (poll) => intToBool(poll.open_p) || intToBool(poll.display_results_p)
    )
  )

  return {
    getActivePoll,
  }
}
